import { render } from "./templateGameOverMaslenica.vue?vue&type=template&id=312200d1&scoped=true"
import script from "./templateGameOverMaslenica.vue?vue&type=script&lang=js"
export * from "./templateGameOverMaslenica.vue?vue&type=script&lang=js"

import "./templateGameOverMaslenica.vue?vue&type=style&index=0&id=312200d1&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312200d1"]])

export default __exports__